import { render } from "./AppTooltip.vue?vue&type=template&id=bf8762c2&scoped=true"
import script from "./AppTooltip.vue?vue&type=script&lang=js"
export * from "./AppTooltip.vue?vue&type=script&lang=js"

import "./AppTooltip.vue?vue&type=style&index=0&id=bf8762c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8762c2"]])

export default __exports__